<template>
  <div>
    <v-flex xs12 sm8 offset-sm2>
      <h2 class="text-center mb-2">Strømbestilling</h2>
      <h5 class="text-center mb-5">Kjøper bestiller strøm fra valgt leverandør, samt nettleie fra det lokale selskapet</h5>
    </v-flex>
    <v-flex xs12 v-if="!stepValues.powerOrderIsApproved">
      <v-flex xs12 sm8 offset-sm2 class="mb-5">
        <slick ref="slick" :options="slickOptions" @afterChange="updateCurrentSlide" v-if="slickReady">
          <template v-for="(item, index) in powerSubs">
            <div class="text-center" :key="index+'1'">
              <img :src="item.img" class="mb-3 logo-img" />
              <h4>{{item.title}}</h4>
              <p>{{item.description}}</p>
            </div>
          </template>
        </slick>
        <div v-else>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-flex>
      <v-flex xs12 sm8 offset-sm2 text-center class="mt-3">&nbsp;</v-flex>
      <v-flex xs12 sm8 offset-sm2>
        <v-btn
          block
          color="primary"
          dark
          class="mt-2"
          v-on:click.stop="dialog = true"
        >Ja, jeg ønsker å bestille strøm</v-btn>
        <v-btn
          block
          color="secondary"
          class="mt-2"
          flat
          @click="next"
        >Nei, jeg ønsker ikke å bestille strøm</v-btn>
      </v-flex>
      <v-flex xs12 sm8 offset-sm2 text-center class="mt-3">
        <p>Strømavtalen er uten bindingstid. For mer informasjon om strømavtalen, besøk leverandørens hjemmesider.<br />
        Utleiers strømabonnement og nettleie blir sagt opp når leietager bestiller strøm.</p>
      </v-flex>
    </v-flex>
    <v-flex xs12 v-else>
      <v-flex xs12 sm8 offset-sm2 text-center>
        <v-card v-if="slickReady">
          <img :src="stepValues.powerSub.img" class="logo-img mt-3" />
          <v-card-title primary-title>
            <div class="w-100">
              <h3 class="headline mb-0">{{stepValues.powerSub.company}}</h3>
              <div text-center>{{stepValues.powerSub.title}}</div>
              <div text-center class="mt-3">
                Blir bestilt på:
                <strong>{{selectedBuyer.firstname}} {{selectedBuyer.lastname}}</strong> når protokoll er levert.
              </div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat color="red" @click="regretPowerOrder">Angre</v-btn>
          </v-card-actions>
        </v-card>
        <div v-else>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-flex>
      <StepButtons @next-page="next" @previous-page="previous" />
    </v-flex>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar :dark="protocol.dark" color="primary">
        <v-btn icon :dark="protocol.dark" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Bestilling av strøm</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :dark="protocol.dark" flat @click="dialog = false">Avbryt</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-select
            label="Velg ansvarlig for strømbestillingen"
            v-model="selectedBuyer"
            :items="buyers"
          >
            <template
              slot="selection"
              slot-scope="data"
            >{{ data.item.firstname }} {{ data.item.lastname }}</template>
            <template
              slot="item"
              slot-scope="data"
            >{{ data.item.firstname }} {{ data.item.lastname }}</template>
          </v-select>
          <v-text-field type="text" label="Fakturaadresse" v-model="stepValues.powerOrderInfo.street"></v-text-field>
          <v-text-field type="text" label="Postnr" v-model="stepValues.powerOrderInfo.zip"></v-text-field>
          <v-text-field type="text" label="Sted" v-model="stepValues.powerOrderInfo.city"></v-text-field>
          <v-flex xs12 sm8 offset-sm2 align-center text-center>
            Strøm fra
            <strong>{{powerSubs[stepValues.currentSlide].company}}</strong> blir bestilt på
            <strong>{{stepValues.selectedBuyer.firstname}} {{stepValues.selectedBuyer.lastname}}</strong>
          </v-flex>
        </v-card-text>
        <v-flex xs12 sm8 offset-sm2>
          <v-btn color="success" block @click="powerOrderApproved">Bekreft strømbestilling</v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      dialog: false,
      buyers: this.getBuyers(),      
      slickOptions: {
        slidesToShow: 1,
        dots: true
      },
      powerSubs: [],
      slickReady: false
    };
  },
  components: { Slick },
  activated: function() {
    this.buyers = this.getBuyers()
  },
  beforeMount: function() {
    if(!this.stepValues.powerOrderInfo) {
      this.stepValues.powerOrderInfo = {
        street: this.protocol.saved_values.address.street,
        zip: this.protocol.saved_values.address.zip,
        city: this.protocol.saved_values.address.city
      }
    }
    this.powerSubs.push({ img: "", company: "", title: "", description: "" })
    this.axios
    .get(
        process.env.VUE_APP_PROTOCOL_API +
          "power_products"
      )
      .then(response => {
        if (!response.data) {
          this.errored = true;
          this.errorText = "Feil: Kunne ikke hente strømabonnementer";
        } else {
          this.powerSubs = response.data
          this.slickReady = true
        }
      })
  },
  methods: {
    updateCurrentSlide() {
      this.stepValues.currentSlide = this.$refs.slick.currentSlide();
    },
    powerOrderApproved() {
      this.stepValues.powerOrderIsApproved = true;
      this.dialog = false;
      this.stepValues.powerSub = this.powerSubs[this.stepValues.currentSlide];
      this.$ga.event(
        "protocol",
        "power_order_approved",
        this.powerSubs[this.stepValues.currentSlide].company
      );
      this.protocol.saved_values.powerOrder = this.stepValues
      this.updateFields();
    },
    regretPowerOrder() {
      this.powerOrderIsApproved = false;
      delete this.protocol.saved_values.powerOrder
      this.updateFields();
    },
    getBuyers: function() {
      if(this.protocol.saved_values.participants) {
        if(this.protocol.saved_values.participants.buyers) {
          if(this.protocol.saved_values.participants.buyers.length > 0) {
          this.selectedBuyer = this.protocol.saved_values.participants.buyers[0]
          return this.protocol.saved_values.participants.buyers
          }
        }
      }
      this.$emit('error', 'Vennligst velg deltakere tilstede');
      this.$router.push('tilstede-salg');
      return [
        {firstname: '', lastname: ''}
      ]
    }
  }
};
</script>

<style>
.slick-slider {
  border: 1px solid #c9c9c9;
  padding: 20px 10px 0px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(229, 229, 229, 1) 100%
  );
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
.slick-slide img,
.logo-img {
  display: inline;
  width: auto;
  height: 60px;
}
.slick-prev:before,
.slick-next:before {
  color: grey;
}
.slick-dots {
  bottom: -40px;
}
.slick-dots li button:before {
  font-size: 20px;
}
</style>
